<template>
  <div>
    <div class="app-content content" v-show="!showUpdate">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Currency"
                bc1="App"
                bc2="Currency"
                bc3="List"
                path="currency"
            ></Breadcrumb>
          </div>
          <div
              class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
          >

          </div>
        </div>
        <div class="content-body">
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="$router.push({ name: 'currency-add' })"
                    >
                      <AddButtonText name="Currency" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CommonTableStore
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :show-per-page="true"
            />
          </div>
        </div>
      </div>
    </div>
    <UpdateCurrency @back="showUpdate = false" v-if="showUpdate"  />
  </div>
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {
    AddButtonText,
    CommandIcon
  },
  created() {
    this.url = "v1/get-currency";
  },
  mounted() {
    localStorage.setItem("url", "v1/get-currency");
    this.checkDataInStore('v1/get-currency')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-currency",
      storageKey: "currency",
      showUpdate:false,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        {
          title: "Symbol",
          valueKey: "symbol",
          html: true,
          alter: function(value) {
            var html = "";
            html = `<div class="badge badge-pill  badge-glow badge-primary">${value}</div>`;
            return html;
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }
            if (row.is_default == 1) {
              html += '<span class="badge badge-secondary ml-1">Default</span>';
            }
            return html;
          }
        },
        {
          title: "Minor Unit",
          valueKey: "minor_unit"
        },
        {
          title: "Rate",
          valueKey: "rate",
          html: true,
          alter: (value) => {
            if (!value) {
              return "-";
            } else {
              return `<span style="" class=" font-weight-bolder text-dark">${parseFloat(
                value/100
              ).toFixed(this.amountDecimalPlaces)}</span>`;
            }
          }
        },
        {
          title: "Type",
          valueKey: "type"
        }
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "currencyUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
            // this.$router.push({ name: "currency-update" });
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "currencyDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    async checkData() {},
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-currency", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("currency");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "currency";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>

